import { render } from "./App.vue?vue&type=template&id=4a1e0ee6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4a1e0ee6&lang=css"

import exportComponent from "/home/emrdev/Project/work/sibugol_dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__